'use client';

import { ReleaseNotesSheetContent } from '@/components/sidebar/shared/floating-menu/components/release-notes/release-notes-sheet-content';
import { useReleaseNoteReadStatus } from '@/components/sidebar/shared/floating-menu/components/release-notes/use-has-read-latest';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';
import { Card } from '@/components/ui/card';
import { Sheet, SheetContent, SheetDescription } from '@/components/ui/sheet';
import { useState } from 'react';

export function ReleaseNoteDashboardBanner() {
  const { hasReadLatest, latestNote, markAsRead, isLoading } =
    useReleaseNoteReadStatus();
  const [sheetOpen, setSheetOpen] = useState(false);

  const showBanner = !isLoading && !hasReadLatest && !!latestNote;

  function handleOpenSheet() {
    markAsRead();
    setSheetOpen(true);
  }

  return (
    <>
      {showBanner && (
        <Card className='flex-row items-center justify-between px-4 py-3'>
          <div className='flex items-center gap-3'>
            <div className='relative flex size-10 items-center justify-center rounded-lg bg-muted'>
              <Icons.releaseNotes className='size-5 text-foreground' />
              <span className='absolute -top-1 -left-1 flex size-3'>
                <span className='absolute inline-flex size-full animate-ping rounded-full bg-primary opacity-75' />
                <span className='relative inline-flex size-3 rounded-full bg-primary' />
              </span>
            </div>
            <span className='min-w-0 flex-1 truncate text-sm font-medium'>
              {latestNote.title}
            </span>
          </div>
          <Button variant='default' size='sm' onClick={handleOpenSheet}>
            Läs om senaste uppdateringen
          </Button>
        </Card>
      )}

      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetContent className='flex flex-col gap-4 p-0'>
          <SheetDescription className='sr-only'>
            Release notes gällande hela applikationen
          </SheetDescription>
          <ReleaseNotesSheetContent />
        </SheetContent>
      </Sheet>
    </>
  );
}
